import { makeStyles } from "@mui/styles";
import { useGameContext } from "../../../context/GameContext";
import { useContent } from "../details/utils";
import FbIcon from "./icons/FbIcon";
import Insta from "./icons/Insta";
import LinkedIcon from "./icons/Linkedin";
import TwitterIcon from "./icons/Twitter";
import WebIcon from "./icons/WebIcon";
import { Icons, SocialMediaContainer, Title } from "./styles";

const useStyles = makeStyles({
	webIconPathClass: {
		fill: "#ffff",
	},
	linkedInIconPathClass: {
		fill: "#000",
	},
});

const iconMapper = (classes) => ({
	webLink: <WebIcon className={classes.webIconPathClass} />,
	twitterLink: <TwitterIcon />,
	fbLink: <FbIcon />,
	instagramLink: <Insta />,
	linkedIn: <LinkedIcon className={classes.linkedInIconPathClass} />,
});

const SocialMediaComponent = ({ socialMediaTitle }) => {
	let { room } = useGameContext();
	const classes = useStyles();
	const mapper = iconMapper(classes);
	const contentMediaTitle = useContent({ contentId: socialMediaTitle, defaultId: "GAME_OVER.social-media.header" });
	return (
		<SocialMediaContainer>
			<Title>{contentMediaTitle}</Title>
			<Icons>
				{room?.mediaLinks &&
					Object.keys(room?.mediaLinks).map((key) => (
						<a key={key} href={room?.mediaLinks?.[key]} target="_blank" rel="noopener noreferrer">
							{mapper[key]}
						</a>
					))}
			</Icons>
		</SocialMediaContainer>
	);
};

export default SocialMediaComponent;
